import { render, staticRenderFns } from "./ExclamationIcon.vue?vue&type=template&id=7a57f350"
import script from "./ExclamationIcon.vue?vue&type=script&lang=ts"
export * from "./ExclamationIcon.vue?vue&type=script&lang=ts"
import style0 from "./ExclamationIcon.vue?vue&type=style&index=0&id=7a57f350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports